import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import { downloadArquivo } from '../arquivo/Actions.js';
import Arquivo from '../arquivo/Arquivo.react.js';
import PageHeader from '../components/PageHeader.react.js';
import CabecalhoEntidade from '../entidades/CabecalhoEntidade.react.js';
import * as actions from './Actions.js';
import AdjudicacaoDetalheInformacao from './AdjudicacaoDetalheInformacao.react.js';

export class AdjudicacaoDetalhe extends Component {
  static propTypes = {
    arquivos: PropTypes.object.isRequired,
    adjudicacao: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    downloadArquivo: PropTypes.func.isRequired,
    findArquivos: PropTypes.func.isRequired,
    findAdjudicacao: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { location, findAdjudicacao, findArquivos } = this.props;

    const {
      entidade,
      exercicio,
      exercicioLicitacao,
      tipoLicitacao,
      licitacao,
      pessoa
    } = getAllValuesFromUrlSearchParams(location);

    findAdjudicacao(
      entidade,
      exercicio,
      exercicioLicitacao,
      tipoLicitacao,
      licitacao,
      pessoa
    ).then(() => {
      findArquivos(
        entidade,
        exercicio,
        exercicioLicitacao,
        tipoLicitacao,
        licitacao,
        pessoa
      );
    });
  }

  render() {
    const { adjudicacao, downloadArquivo, arquivos } = this.props;

    const arquivosList = arquivos
      .map(item => item.get('arquivoCompras'))
      .filter(item => !!item);

    return (
      <div>
        <Helmet title={'Adjudicação'} />

        <BotaoImprimir />

        <PageHeader
          location={this.props.location}
          textoDetalhe={`Adjudicação: ${adjudicacao.get(
            'entidade'
          )}/${adjudicacao.get('licitacao')}`}
        />

        <CabecalhoEntidade />

        <AdjudicacaoDetalheInformacao adjudicacao={adjudicacao} />

        <Panel isTable tableResponsive title="Anexos">
          <Arquivo arquivos={arquivosList} onDownload={downloadArquivo} />
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    adjudicacao: state.adjudicacao.get('adjudicacao'),
    arquivos: state.adjudicacao.get('arquivos')
  };
}

const allActions = {
  ...actions,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(AdjudicacaoDetalhe);
